// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607280204/js/" + chunkId + "." + {"44":"67f759a7","225":"09ddd5f9","481":"8ad7578f","486":"b89cefc3","770":"ef0a879c"}[chunkId] + ".0.5466351788312376.chunk.js";
};